import { useEffect, useState } from "react";

/**
 * Hook that returns a `tick` counter that increments every `intervalMs`.
 * Components that use this will re-render periodically,
 * keeping relative time labels (e.g. "3m ago") accurate.
 *
 * Usage:
 *   const tick = useTimeRefresh(30_000); // re-render every 30s
 *   // use `tick` as a dependency or just let the re-render refresh timeAgo() calls
 */
export function useTimeRefresh(intervalMs = 30_000) {
    const [tick, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick(t => t + 1), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);
    return tick;
}
